import { gql } from 'graphql.macro';

export const vismaStatusTemplate = gql`
    query vismaStatus {
        vismaStatus {
            authorized
            enabled
            clientId
        }
    }
`;
